// import { useState, useMemo, useEffect } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import { Button } from '@/components/ui/button';
// import PlanGuard from '@/components/PlanGuard';
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
// import { Textarea } from '@/components/ui/textarea';
// import { motion } from 'framer-motion';
// import axios from 'axios';
// import { toast } from 'sonner';
// import { FaArrowLeft, FaCalculator, FaUtensils, FaUser, FaRunning, FaBullseye, FaBrain, FaInfoCircle, FaPaperPlane } from 'react-icons/fa';
// import ContinuationForm from '@/components/ContinuationForm';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

// // ============================================================
// // CONSTANTES
// // ============================================================
// const ACTIVITY_LEVELS = {
//   sedentario: { label: 'Sedentario', factor: 1.2, desc: 'Poco o ningún ejercicio' },
//   ligero: { label: 'Ligero', factor: 1.375, desc: '1-2 días de ejercicio por semana' },
//   moderado: { label: 'Moderado', factor: 1.55, desc: '3-4 días por semana' },
//   alto: { label: 'Alto', factor: 1.725, desc: '5-6 días por semana' }
// };

// const GOALS = {
//   perder_grasa: {
//     label: 'Perder grasa',
//     pct: -20,
//     color: '#EF4444',
//     tip: 'Ideal si quieres reducir % de grasa corporal y bajar de talla. Recomendado para quienes se sienten con sobrepeso, buscan verse más definidas y priorizan bajar de peso sin perder tanta masa muscular.'
//   },
//   ganar_musculo: {
//     label: 'Ganar masa muscular',
//     pct: 15,
//     color: '#3B82F6',
//     tip: 'Ideal si te ves delgada, tu ropa te queda holgada o quieres aumentar volumen (glúteos, piernas, brazos). Requiere entrenamiento con progresión de cargas y comer un poco más de lo que gastas.'
//   },
//   mantener: {
//     label: 'Mantener peso',
//     pct: 0,
//     color: '#22C55E',
//     tip: 'Ideal si estás conforme con tu peso actual y solo quieres mejorar hábitos, energía y salud. Cero superávit, cero déficit.'
//   },
//   recomposicion: {
//     label: 'Recomposición corporal',
//     pct: -5,
//     color: '#F59E0B',
//     tip: 'Ideal si quieres bajar grasa Y ganar músculo AL MISMO TIEMPO. Recomendado para principiantes o quienes vuelven de una pausa. Es más lento pero cambia tu cuerpo por dentro (menos grasa, más músculo) sin necesariamente bajar mucho de peso en la balanza.'
//   },
// };

// const DIET_OPTIONS = {
//   equilibrada: {
//     label: 'Equilibrada', p: 30, c: 40, f: 30,
//     text: 'Recomendada si no presentas problemas digestivos con ningún macronutriente y buscas una alimentación balanceada. Es ideal para la mayoría de las personas que desean mantener energía estable durante el día y una dieta sostenible a largo plazo.',
//     reason: 'Tu perfil metabólico no muestra sensibilidades marcadas hacia ningún macronutriente, por eso una distribución balanceada te da energía sostenida durante todo el día y resultados constantes sin restricciones drásticas.'
//   },
//   alta_proteina: {
//     label: 'Alta en Proteína', p: 40, c: 35, f: 25,
//     text: 'Ideal si tu objetivo es aumentar o mantener masa muscular, mejorar la saciedad o controlar el apetito. También puede ser útil si entrenas con frecuencia o estás en un proceso de pérdida de grasa.',
//     reason: 'Elegimos esta distribución porque tu nivel de hambre y tus entrenamientos indican que necesitas mayor saciedad y soporte muscular. La proteína te va a mantener satisfecha, controlar antojos y preservar tu masa muscular en cada ciclo.'
//   },
//   alta_carbos: {
//     label: 'Alta en Carbohidratos', p: 25, c: 50, f: 25,
//     text: 'Recomendada si tienes un metabolismo rápido, realizas entrenamientos intensos o frecuentes, o si sueles perder peso con facilidad. Este tipo de distribución puede ayudarte a mantener niveles altos de energía y mejorar el rendimiento físico.',
//     reason: 'Tu metabolismo rápido y tu nivel de actividad demandan más energía disponible. Con más carbohidratos vas a rendir mejor en tus entrenamientos, recuperar el glucógeno y construir volumen muscular sin sacrificar rendimiento.'
//   },
//   baja_carbos: {
//     label: 'Baja en Carbohidratos (Low Carb)', p: 35, c: 25, f: 40,
//     text: 'Puede ser una buena opción si tiendes a sentirte inflamado al consumir muchos carbohidratos, si te cuesta perder grasa corporal o si prefieres una alimentación con mayor cantidad de grasas y proteínas que te mantenga saciado por más tiempo.',
//     reason: 'Tu perfil sugiere metabolismo más lento y tendencia a retener líquidos, así que bajar los carbohidratos te ayuda a desinflamar, controlar la insulina y avanzar en tu pérdida de grasa de forma sostenida.'
//   },
//   alta_grasa: {
//     label: 'Alta en Grasas Saludables', p: 30, c: 30, f: 40,
//     text: 'Recomendada para personas que prefieren una alimentación con mayor presencia de grasas saludables como aguacate, frutos secos, aceite de oliva y pescados grasos, manteniendo una cantidad moderada de carbohidratos sin llegar a una dieta cetogénica.',
//     reason: 'Tu sensibilidad hormonal, tu descanso y tu hambre baja durante el día encajan muy bien con más grasas saludables. Vas a regular tus hormonas, mejorar el sueño y sentir saciedad prolongada sin picos de energía.'
//   },
//   cetogenica: {
//     label: 'Cetogénica (Keto)', p: 30, c: 10, f: 60,
//     text: 'Indicado para quienes desean seguir una dieta muy baja en carbohidratos y alta en grasas. Este enfoque busca que el cuerpo utilice principalmente grasa como fuente de energía. Suele ser más restrictivo y se recomienda para personas que ya están familiarizadas con este tipo de alimentación.',
//     reason: 'Con retención marcada y respuesta lenta a otras distribuciones, la cetogénica cambia tu fuente principal de energía a la grasa. Esto acelera la pérdida de grasa, reduce inflamación y estabiliza tu energía a lo largo del día.'
//   }
// };

// function suggestDiet(profile) {
//   const {
//     metabolism = 'normal',
//     hungerLevel = 'moderado',
//     waterRetention = 'no',
//     sleepQuality = 'buena',
//     goal = ''
//   } = profile || {};

//   // 1) Cetogénica: metabolismo lento + retención + mal sueño (perfil con inflamación importante)
//   if (metabolism === 'lento' && waterRetention === 'si' && sleepQuality === 'mala') return 'cetogenica';
//   // 2) Baja en carbos: metabolismo lento con retención de líquidos
//   if (metabolism === 'lento' && waterRetention === 'si') return 'baja_carbos';
//   // 3) Alta en carbos: metabolismo rápido + hambre alto (necesita energía)
//   if (metabolism === 'rapido' && hungerLevel === 'alto') return 'alta_carbos';
//   // 4) Alta en proteína: definición / recomposición / hambre alto sin metabolismo rápido
//   if (goal === 'perder_grasa' || goal === 'recomposicion') return 'alta_proteina';
//   if (hungerLevel === 'alto' && metabolism !== 'rapido') return 'alta_proteina';
//   // 5) Alta en grasas saludables: mal sueño + metabolismo lento sin retención
//   if (sleepQuality === 'mala' && metabolism === 'lento' && waterRetention === 'no') return 'alta_grasa';
//   // 6) Alta en carbos para ganancia muscular con metabolismo rápido
//   if (goal === 'ganar_musculo' && metabolism === 'rapido') return 'alta_carbos';
//   // 7) Equilibrada por defecto
//   return 'equilibrada';
// }

// // ============================================================
// // COMPONENTE PRINCIPAL
// // ============================================================
// const MacroCalculator = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const isContinuation = searchParams.get('continuation') === 'true';

//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     gender: '',
//     weight: '',
//     height: '',
//     age: '',
//     activityLevel: '',
//     goal: '',
//     hungerLevel: 'moderado',
//     // 🧬 Perfil metabólico Fit Evolution
//     metabolism: 'normal',      // rapido / normal / lento
//     waterRetention: 'no',      // si / no
//     sleepQuality: 'buena',     // buena / regular / mala
//     preference: 'equilibrada',
//     mealsPerDay: '5',
//     postWorkoutMeal: '',
//     allergies: '',
//     dislikedFoods: '',
//     // 💪 Entrenamiento
//     trainingLevel: '',        // novato / intermedio / avanzado
//     trainingDays: '',         // 3 / 4 / 5 / 6
//     trainingLocation: '',     // casa / gym / ambos
//     sessionDuration: '',      // 45min / 60min / 75min / 90min
//     problematicExercises: '', // texto libre
//     availableEquipment: [],   // 🏠 solo para location='casa' — lista de IDs de implementos que la clienta tiene
//     // 💊 Suplementación (Fit Evolution)
//     usesSupplements: null,    // true | false — se pregunta explícitamente
//   });
//   const [equipmentCatalog, setEquipmentCatalog] = useState([]);

//   // Cargar catálogo de implementos al montar (solo se usa si trainingLocation === 'casa')
//   useEffect(() => {
//     let ignore = false;
//     axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/fit-evolution/equipment-catalog`)
//       .then(r => { if (!ignore) setEquipmentCatalog(r.data?.catalog || []); })
//       .catch(() => {});
//     return () => { ignore = true; };
//   }, []);

//   const toggleEquipment = (id) => {
//     setFormData(prev => {
//       const has = (prev.availableEquipment || []).includes(id);
//       return {
//         ...prev,
//         availableEquipment: has
//           ? prev.availableEquipment.filter(x => x !== id)
//           : [...(prev.availableEquipment || []), id],
//       };
//     });
//   };

//   const update = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

//   // Auto-sugerencia de dieta basada en el perfil metabólico completo
//   const suggestedDiet = useMemo(() => {
//     return suggestDiet({
//       metabolism: formData.metabolism,
//       hungerLevel: formData.hungerLevel,
//       waterRetention: formData.waterRetention,
//       sleepQuality: formData.sleepQuality,
//       goal: formData.goal,
//     });
//   }, [formData.metabolism, formData.hungerLevel, formData.waterRetention, formData.sleepQuality, formData.goal]);

//   // Auto-aplicar sugerencia cuando cambia (solo si no se ha elegido manualmente)
//   const [manualDiet, setManualDiet] = useState(false);
//   const activePref = manualDiet ? formData.preference : suggestedDiet;
//   const selectedDiet = DIET_OPTIONS[activePref];

//   // Explicación humana de la dieta recomendada — texto FIJO por tipo de dieta.
//   // Sin llamada a LLM ni Universal Key. El texto se lee de DIET_OPTIONS[activePref].reason.
//   const dietReason = (DIET_OPTIONS[activePref]?.reason) || 'El sistema eligió esta dieta según tu perfil metabólico.';

//   // ============================================================
//   // CÁLCULO DINÁMICO DE MACROS
//   // ============================================================
//   const macros = useMemo(() => {
//     const w = parseFloat(formData.weight) || 0;
//     const h = parseFloat(formData.height) || 0;
//     const a = parseInt(formData.age) || 0;
//     if (w <= 0 || h <= 0 || a <= 0 || !formData.gender || !formData.activityLevel || !formData.goal) return null;

//     let tmb;
//     if (formData.gender === 'male') {
//       tmb = (10 * w) + (6.25 * h) - (5 * a) + 5;
//     } else {
//       tmb = (10 * w) + (6.25 * h) - (5 * a) - 161;
//     }

//     const actFactor = ACTIVITY_LEVELS[formData.activityLevel]?.factor || 1.55;
//     const maintenance = Math.round(tmb * actFactor);
//     const goalAdj = GOALS[formData.goal]?.pct || 0;
//     const targetCalories = Math.round(maintenance * (1 + goalAdj / 100));

//     const diet = DIET_OPTIONS[activePref] || DIET_OPTIONS.equilibrada;
//     const proteinG = Math.round((targetCalories * diet.p / 100) / 4);
//     const carbsG = Math.round((targetCalories * diet.c / 100) / 4);
//     const fatsG = Math.round((targetCalories * diet.f / 100) / 9);

//     return {
//       calories: targetCalories, protein: proteinG, carbs: carbsG, fats: fatsG,
//       method: 'Mifflin-St Jeor', tmb: Math.round(tmb), maintenance, goalAdjustment: goalAdj,
//       pPct: diet.p, cPct: diet.c, fPct: diet.f
//     };
//   }, [formData.weight, formData.height, formData.age, formData.gender, formData.activityLevel, formData.goal, activePref]);

//   const validateAndSubmit = async () => {
//     if (!formData.fullName || !formData.email) { toast.error('Completa tu nombre y correo electrónico'); return; }
//     if (!macros) { toast.error('Completa todos los campos requeridos'); return; }
//     if (!formData.postWorkoutMeal) { toast.error('Selecciona tu comida post entrenamiento'); return; }
//     if (!formData.allergies || !formData.dislikedFoods) { toast.error('Indica tus alergias y alimentos que no te gustan (escribe "Ninguna" si no aplica)'); return; }
//     if (!formData.trainingLevel) { toast.error('Selecciona tu nivel de entrenamiento'); return; }
//     if (!formData.trainingDays) { toast.error('Indica cuántos días entrenas por semana'); return; }
//     if (!formData.trainingLocation) { toast.error('Selecciona dónde vas a entrenar (Casa / Gym / Ambos)'); return; }
//     if (!formData.sessionDuration) { toast.error('Selecciona la duración de tu sesión'); return; }

//     // Envío directo al backend (sin MealBuilder). El admin generará las recetas.
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('deisycfit_token');
//       const mealsCount = parseInt(formData.mealsPerDay) || 5;
//       await axios.post(`${API}/meal-plan/save`, {
//         selectedFoods: {},
//         macros: { calories: macros.calories, protein: macros.protein, carbs: macros.carbs, fats: macros.fats },
//         formData: { fullName: formData.fullName || '', email: formData.email || '' },
//         mealsCount,
//         postWorkoutMeal: formData.postWorkoutMeal || '2',
//         allergies: formData.allergies || '',
//         dislikedFoods: formData.dislikedFoods || '',
//         profile_data: {
//           gender: formData.gender,
//           age: parseInt(formData.age) || undefined,
//           weight: parseFloat(formData.weight) || undefined,
//           height: parseFloat(formData.height) || undefined,
//           activity_level: formData.activityLevel,
//           goal: formData.goal,
//         },
//         metabolic_profile: {
//           metabolism: formData.metabolism,
//           hunger_level: formData.hungerLevel,
//           water_retention: formData.waterRetention,
//           sleep_quality: formData.sleepQuality,
//           goal: formData.goal,
//           recommended_diet: activePref,
//           recommended_diet_label: DIET_OPTIONS[activePref]?.label,
//         },
//         training_profile: {
//           level: formData.trainingLevel,
//           training_days: formData.trainingDays,
//           training_location: formData.trainingLocation,
//           session_duration: formData.sessionDuration,
//           problematic_exercises: formData.problematicExercises,
//           available_equipment: (formData.availableEquipment || []),
//           goal: formData.goal,
//           training_experience: formData.trainingLevel,
//         },
//         // 💊 Suplementación
//         uses_supplements: formData.usesSupplements === true,
//       }, { headers: token ? { 'Authorization': `Bearer ${token}` } : {} });
//       toast.success('¡Formulario enviado! Tu plan estará listo en máximo 24 horas.');
//       // Marca en sessionStorage para que el Dashboard sepa que el envío fue exitoso
//       // (evita el flash del CTA "Contesta tu perfil" mientras basicPlanStatus carga)
//       try { sessionStorage.setItem('fe_just_submitted', String(Date.now())); } catch (_e) { /* noop */ }
//       // Redirigir DIRECTO a la pantalla de "Preparando (24h)" para que la usuaria vea
//       // el badge/countdown inmediatamente y no piense que la sacaron del sistema.
//       setTimeout(() => navigate('/fit-evolution/preparing', { replace: true }), 800);
//     } catch (error) {
//       console.error('Error enviando formulario:', error.response?.data || error.message);
//       toast.error(error.response?.data?.detail || 'Error al enviar el formulario');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const inputCls = "bg-white/15 border-white/30 text-white font-medium text-base placeholder:text-gray-400";
//   const sectionCls = "p-5 rounded-xl";
//   const numMeals = parseInt(formData.mealsPerDay) || 5;

//   // Actualización mensual: formulario de continuación (después de hooks para respetar rules-of-hooks)
//   if (isContinuation) {
//     return (
//       <PlanGuard allowedPlans={['basic']}>
//         <div className="min-h-screen py-12 px-4" style={{ background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)' }}>
//           <div className="max-w-4xl mx-auto">
//             <button onClick={() => navigate('/dashboard')} className="flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors">
//               <FaArrowLeft /> Volver al Dashboard
//             </button>
//             <ContinuationForm formType="diet" onSuccess={() => navigate('/dashboard')} onCancel={() => navigate('/dashboard')} />
//           </div>
//         </div>
//       </PlanGuard>
//     );
//   }

//   return (
//     <PlanGuard requiredPlan="basic" featureName="el Generador de Dietas">
//       <div className="min-h-screen py-12 px-6" style={{ backgroundColor: '#0a0a0a' }}>
//         <div className="fixed inset-0 z-0 pointer-events-none" style={{
//           background: 'radial-gradient(circle at 20% 80%, rgba(var(--brand-primary-glow),0.12), transparent 50%), radial-gradient(circle at 80% 20%, rgba(0,240,255,0.08), transparent 40%)'
//         }} />

//         <div className="max-w-5xl mx-auto relative z-10">
//           <Button variant="ghost" onClick={() => navigate('/dashboard')}
//             className="mb-6 text-gray-400 hover:text-white hover:bg-white/10" data-testid="back-button">
//             <FaArrowLeft className="mr-2" /> Volver al Dashboard
//           </Button>

//           {(
//             <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
//               <Card style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
//                 <CardHeader>
//                   <div className="flex items-center gap-3 mb-2">
//                     <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white"
//                       style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}>
//                       <FaCalculator className="text-2xl" />
//                     </div>
//                     <div>
//                       <CardTitle className="text-3xl text-white font-black" data-testid="page-title">Mi Plan de Alimentación</CardTitle>
//                       <CardDescription className="text-gray-200 text-base">Diseñamos tu plan de alimentación perfecto según tus metas</CardDescription>
//                     </div>
//                   </div>
//                 </CardHeader>
//                 <CardContent className="space-y-5">

//                   {/* Datos de contacto */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(0,240,255,0.08)', border: '1px solid rgba(0,240,255,0.25)' }}>
//                     <h3 className="font-semibold text-cyan-400 mb-4">Datos de Contacto</h3>
//                     <div className="grid md:grid-cols-2 gap-4">
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Nombre Completo *</Label>
//                         <Input value={formData.fullName} onChange={(e) => update('fullName', e.target.value)}
//                           placeholder="Tu nombre completo" className={inputCls} data-testid="input-fullname" />
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Correo Electrónico *</Label>
//                         <Input type="email" value={formData.email} onChange={(e) => update('email', e.target.value)}
//                           placeholder="tu@email.com" className={inputCls} data-testid="input-email" />
//                       </div>
//                     </div>
//                   </div>

//                   {/* SECCIÓN 1 — DATOS PERSONALES */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(var(--brand-primary-glow),0.08)', border: '1px solid rgba(var(--brand-primary-glow),0.25)' }}>
//                     <h3 className="font-semibold text-pink-400 mb-4 flex items-center gap-2">
//                       <FaUser /> Sección 1 — Datos Personales
//                     </h3>
//                     <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Sexo *</Label>
//                         <Select value={formData.gender} onValueChange={(v) => update('gender', v)}>
//                           <SelectTrigger className={inputCls} data-testid="select-gender"><SelectValue placeholder="Selecciona" /></SelectTrigger>
//                           <SelectContent>
//                             <SelectItem value="male">Hombre</SelectItem>
//                             <SelectItem value="female">Mujer</SelectItem>
//                           </SelectContent>
//                         </Select>
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Edad *</Label>
//                         <Input type="number" value={formData.age} onChange={(e) => update('age', e.target.value)}
//                           placeholder="30" className={inputCls} data-testid="input-age" />
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Peso (kg) *</Label>
//                         <Input type="number" value={formData.weight} onChange={(e) => update('weight', e.target.value)}
//                           placeholder="65" className={inputCls} data-testid="input-weight" />
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Estatura (cm) *</Label>
//                         <Input type="number" value={formData.height} onChange={(e) => update('height', e.target.value)}
//                           placeholder="162" className={inputCls} data-testid="input-height" />
//                         <p className="text-xs text-amber-400/80">Sin puntos. Ej: 162 cm, no 1.62</p>
//                       </div>
//                     </div>
//                   </div>

//                   {/* SECCIÓN 2 — ACTIVIDAD FÍSICA */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.25)' }}>
//                     <h3 className="font-semibold text-emerald-400 mb-4 flex items-center gap-2">
//                       <FaRunning /> Sección 2 — Actividad Física
//                     </h3>
//                     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//                       {Object.entries(ACTIVITY_LEVELS).map(([key, val]) => {
//                         const active = formData.activityLevel === key;
//                         return (
//                           <button key={key} data-testid={`activity-${key}`}
//                             className={`p-4 rounded-xl border text-left transition-all ${
//                               active ? 'border-emerald-500 bg-emerald-500/20 ring-1 ring-emerald-500' : 'border-white/10 bg-white/5 hover:border-white/25'
//                             }`}
//                             onClick={() => update('activityLevel', key)}>
//                             <p className={`text-sm font-bold ${active ? 'text-emerald-300' : 'text-white'}`}>{val.label}</p>
//                             <p className="text-[11px] text-gray-200 mt-1">{val.desc}</p>
//                           </button>
//                         );
//                       })}
//                     </div>
//                   </div>

//                   {/* SECCIÓN 3 — OBJETIVO */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)' }}>
//                     <h3 className="font-semibold text-amber-400 mb-4 flex items-center gap-2">
//                       <FaBullseye /> Sección 3 — Objetivo
//                     </h3>
//                     <p className="text-xs text-gray-200 mb-4 leading-relaxed">
//                       Toca cada opción para leer la recomendación y elegir la que mejor se ajusta a tu meta actual. Puedes cambiarla más adelante si tu proceso evoluciona.
//                     </p>
//                     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//                       {Object.entries(GOALS).map(([key, val]) => {
//                         const active = formData.goal === key;
//                         return (
//                           <button key={key} data-testid={`goal-${key}`}
//                             className={`p-4 rounded-xl border text-center transition-all ${
//                               active ? 'ring-1' : 'border-white/10 bg-white/5 hover:border-white/25'
//                             }`}
//                             style={active ? { borderColor: val.color, backgroundColor: `${val.color}22`, boxShadow: `0 0 0 1px ${val.color}` } : {}}
//                             onClick={() => { update('goal', key); setManualDiet(false); }}>
//                             <p className={`text-sm font-bold ${active ? 'text-white' : 'text-white/95'}`}>{val.label}</p>
//                             <p className="text-[11px] text-gray-200 mt-1">{val.pct > 0 ? '+' : ''}{val.pct}% kcal</p>
//                           </button>
//                         );
//                       })}
//                     </div>
//                     {formData.goal && GOALS[formData.goal]?.tip && (
//                       <div
//                         className="mt-4 rounded-xl p-4 text-sm leading-relaxed"
//                         style={{
//                           background: `${GOALS[formData.goal].color}15`,
//                           border: `1px solid ${GOALS[formData.goal].color}40`,
//                           color: '#F5F5F5'
//                         }}
//                         data-testid={`goal-tip-${formData.goal}`}
//                       >
//                         <p className="font-bold mb-1" style={{ color: GOALS[formData.goal].color }}>
//                           💡 ¿Cuándo elegir "{GOALS[formData.goal].label}"?
//                         </p>
//                         <p className="text-gray-100">{GOALS[formData.goal].tip}</p>
//                       </div>
//                     )}
//                   </div>

//                   {/* SECCIÓN 4 — PERFIL METABÓLICO */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(168,85,247,0.08)', border: '1px solid rgba(168,85,247,0.25)' }}>
//                     <h3 className="font-semibold text-purple-400 mb-2 flex items-center gap-2">
//                       <FaBrain /> Sección 4 — Perfil Metabólico
//                     </h3>
//                     <p className="text-xs text-gray-200 mb-5">Estas preguntas ayudan al sistema a decidir la distribución de macronutrientes.</p>

//                     <div className="space-y-5">
//                       <div>
//                         <p className="text-base text-gray-100 mb-3">¿Cómo es tu nivel de hambre durante el día?</p>
//                         <div className="grid grid-cols-3 gap-3">
//                           {[
//                             { id: 'alto', label: 'Alto', emoji: '🍽️', desc: 'Como y sigues con ganas de más' },
//                             { id: 'moderado', label: 'Moderado', emoji: '👌', desc: 'Comes y quedas satisfecha' },
//                             { id: 'bajo', label: 'Bajo', emoji: '🤏', desc: 'A veces se te olvida comer' }
//                           ].map(opt => {
//                             const active = formData.hungerLevel === opt.id;
//                             return (
//                               <button key={opt.id} data-testid={`hunger-${opt.id}`}
//                                 className={`p-3 rounded-xl border text-center transition-all ${
//                                   active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
//                                 }`}
//                                 onClick={() => { update('hungerLevel', opt.id); setManualDiet(false); }}>
//                                 <span className="text-xl">{opt.emoji}</span>
//                                 <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
//                                 <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>

//                       {/* 🧬 Perfil metabólico Fit Evolution */}
//                       <div>
//                         <p className="text-base text-gray-100 mb-3">¿Cómo describirías tu metabolismo?</p>
//                         <div className="grid grid-cols-3 gap-3">
//                           {[
//                             { id: 'rapido', label: 'Rápido', emoji: '🔥', desc: 'Comes mucho y no subes de peso fácil' },
//                             { id: 'normal', label: 'Normal', emoji: '⚖️', desc: 'Tu peso se mantiene con dieta equilibrada' },
//                             { id: 'lento', label: 'Lento', emoji: '🐢', desc: 'Subes de peso con facilidad aunque comas poco' }
//                           ].map(opt => {
//                             const active = formData.metabolism === opt.id;
//                             return (
//                               <button key={opt.id} type="button" data-testid={`metabolism-${opt.id}`}
//                                 className={`p-3 rounded-xl border text-center transition-all ${
//                                   active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
//                                 }`}
//                                 onClick={() => { update('metabolism', opt.id); setManualDiet(false); }}>
//                                 <span className="text-xl">{opt.emoji}</span>
//                                 <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
//                                 <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>

//                       <div>
//                         <p className="text-base text-gray-100 mb-3">¿Sueles retener líquidos?</p>
//                         <div className="grid grid-cols-2 gap-3">
//                           {[
//                             { id: 'si', label: 'Sí', emoji: '💧', desc: 'Manos, cara o piernas hinchadas con frecuencia' },
//                             { id: 'no', label: 'No', emoji: '✨', desc: 'No sientes hinchazón normalmente' }
//                           ].map(opt => {
//                             const active = formData.waterRetention === opt.id;
//                             return (
//                               <button key={opt.id} type="button" data-testid={`retention-${opt.id}`}
//                                 className={`p-3 rounded-xl border text-center transition-all ${
//                                   active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
//                                 }`}
//                                 onClick={() => { update('waterRetention', opt.id); setManualDiet(false); }}>
//                                 <span className="text-xl">{opt.emoji}</span>
//                                 <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
//                                 <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>

//                       <div>
//                         <p className="text-base text-gray-100 mb-3">¿Cómo describirías tu calidad de sueño?</p>
//                         <div className="grid grid-cols-3 gap-3">
//                           {[
//                             { id: 'buena', label: 'Buena', emoji: '😌', desc: '7-9 horas seguidas y despiertas descansada' },
//                             { id: 'regular', label: 'Regular', emoji: '😐', desc: '5-6 horas o te despiertas varias veces' },
//                             { id: 'mala', label: 'Mala', emoji: '😩', desc: 'Menos de 5 horas o insomnio frecuente' }
//                           ].map(opt => {
//                             const active = formData.sleepQuality === opt.id;
//                             return (
//                               <button key={opt.id} type="button" data-testid={`sleep-${opt.id}`}
//                                 className={`p-3 rounded-xl border text-center transition-all ${
//                                   active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
//                                 }`}
//                                 onClick={() => { update('sleepQuality', opt.id); setManualDiet(false); }}>
//                                 <span className="text-xl">{opt.emoji}</span>
//                                 <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
//                                 <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
//                               </button>
//                             );
//                           })}
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* SECCIÓN 5 — DIETA RECOMENDADA AUTOMÁTICAMENTE (auto según perfil metabólico) */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(var(--brand-primary-glow),0.08)', border: '1px solid rgba(var(--brand-primary-glow),0.25)' }} data-testid="diet-auto-recommendation-section">
//                     <h3 className="font-semibold text-pink-400 mb-2 flex items-center gap-2">
//                       <FaUtensils /> Sección 5 — Tu Dieta Recomendada
//                     </h3>
//                     <p className="text-xs text-gray-400 mb-4">
//                       El sistema eligió automáticamente el tipo de dieta más adecuado según tu perfil metabólico, hambre, sueño y objetivo. No necesitas elegir nada.
//                     </p>

//                     {selectedDiet && (
//                       <div className="p-4 rounded-xl border border-pink-500/40 bg-pink-500/10" data-testid="diet-explanation">
//                         <div className="flex items-center justify-between mb-2">
//                           <p className="text-lg font-bold text-pink-300" data-testid="diet-recommended-label">{selectedDiet.label}</p>
//                           <span className="text-xs px-2 py-1 rounded-full bg-pink-500/20 text-pink-300 font-semibold">Recomendada para ti</span>
//                         </div>
//                         <p className="text-xs text-gray-200 mb-3" data-testid="diet-recommended-macros">
//                           {DIET_OPTIONS[activePref].p}% Proteína / {DIET_OPTIONS[activePref].c}% Carbohidratos / {DIET_OPTIONS[activePref].f}% Grasas
//                         </p>
//                         {/* 💡 Explicación humana del por qué (texto FIJO por tipo de dieta) */}
//                         <div className="mb-3 p-3 rounded-lg border border-purple-500/30 bg-purple-500/10" data-testid="diet-reason-box">
//                           <p className="text-xs uppercase tracking-wider text-purple-300 font-bold mb-1">¿Por qué esta dieta?</p>
//                           <p className="text-sm text-purple-100" data-testid="diet-reason-text">{dietReason}</p>
//                         </div>
//                         <p className="text-base text-gray-100 leading-relaxed">{selectedDiet.text}</p>
//                       </div>
//                     )}

//                     <p className="text-xs text-gray-200 mt-3 flex items-start gap-2">
//                       <FaInfoCircle className="mt-0.5 flex-shrink-0 text-gray-600" />
//                       Si cambias alguna de las respuestas de tu perfil metabólico, la dieta recomendada se actualizará automáticamente.
//                     </p>
//                   </div>

//                   {/* Configuración de Comidas */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.25)' }}>
//                     <h3 className="font-semibold text-indigo-400 mb-4">Configuración de Comidas</h3>
//                     <div className="grid md:grid-cols-2 gap-4">
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Comidas por Día</Label>
//                         <Select value={formData.mealsPerDay} onValueChange={(v) => update('mealsPerDay', v)}>
//                           <SelectTrigger className={inputCls} data-testid="select-meals"><SelectValue /></SelectTrigger>
//                           <SelectContent>
//                             {[3,4,5,6,7].map(n => <SelectItem key={n} value={String(n)}>{n} comidas</SelectItem>)}
//                           </SelectContent>
//                         </Select>
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Comida Post Entrenamiento <span className="text-white/60 font-normal">(la comida después de entrenar)</span> *</Label>
//                         <Select value={formData.postWorkoutMeal} onValueChange={(v) => update('postWorkoutMeal', v)}>
//                           <SelectTrigger className={inputCls} data-testid="select-post-workout"><SelectValue placeholder="Selecciona" /></SelectTrigger>
//                           <SelectContent>
//                             {Array.from({ length: numMeals }, (_, i) => i + 1).map(n => (
//                               <SelectItem key={n} value={String(n)}>Comida {n}</SelectItem>
//                             ))}
//                           </SelectContent>
//                         </Select>
//                         <p className="text-xs text-gray-200">Sin grasas añadidas. En días de descanso se omite esta comida.</p>
//                       </div>
//                     </div>
//                   </div>

//                   {/* SECCIÓN 6 — ENTRENAMIENTO */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(0,240,255,0.10)', border: '1px solid rgba(0,240,255,0.30)', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                     <h3 className="font-bold text-cyan-300 text-lg mb-4 flex items-center gap-2 normal-case" style={{ letterSpacing: 'normal' }}>
//                       <FaRunning /> Sección 6 — Entrenamiento
//                     </h3>
//                     <p className="text-base text-gray-100 mb-5 normal-case" style={{ letterSpacing: 'normal' }}>Con esto armamos tu rutina personalizada Fit Evolution.</p>

//                     {/* Nivel */}
//                     <div className="mb-5">
//                       <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal' }}>Tu nivel de entrenamiento *</Label>
//                       <div className="grid grid-cols-3 gap-3">
//                         {[
//                           { v: 'novato', l: 'Novato', d: 'Nunca he entrenado o poco tiempo' },
//                           { v: 'intermedio', l: 'Intermedio', d: 'Entreno hace 6+ meses' },
//                           { v: 'avanzado', l: 'Avanzado', d: 'Entreno hace 2+ años' }
//                         ].map(o => {
//                           const active = formData.trainingLevel === o.v;
//                           return (
//                             <button key={o.v} data-testid={`training-level-${o.v}`}
//                               onClick={() => update('trainingLevel', o.v)}
//                               className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
//                               style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                               <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.l}</p>
//                               <p className="text-sm text-gray-100 mt-1 leading-snug normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.d}</p>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </div>

//                     {/* Días por semana */}
//                     <div className="mb-5">
//                       <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>Días que entrenas por semana *</Label>
//                       <div className="grid grid-cols-4 gap-3">
//                         {['3', '4', '5', '6'].map(v => {
//                           const active = formData.trainingDays === v;
//                           return (
//                             <button key={v} data-testid={`training-days-${v}`}
//                               onClick={() => update('trainingDays', v)}
//                               className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
//                               style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                               <p className={`font-black text-2xl normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{v}</p>
//                               <p className="text-sm text-gray-100 normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>días</p>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </div>

//                     {/* Lugar */}
//                     <div className="mb-5">
//                       <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>¿Dónde vas a entrenar? *</Label>
//                       <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
//                         {[
//                           { v: 'casa', l: 'En Casa', d: 'Material básico o sin equipo', i: '🏠' },
//                           { v: 'gym', l: 'En el Gym', d: 'Máquinas y peso libre', i: '🏋️' },
//                           { v: 'ambos', l: 'Ambos', d: 'A veces casa, a veces gym', i: '🔀' }
//                         ].map(o => {
//                           const active = formData.trainingLocation === o.v;
//                           return (
//                             <button key={o.v} data-testid={`training-location-${o.v}`}
//                               onClick={() => update('trainingLocation', o.v)}
//                               className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
//                               style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                               <div className="text-3xl mb-1">{o.i}</div>
//                               <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.l}</p>
//                               <p className="text-sm text-gray-100 mt-1 leading-snug normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.d}</p>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </div>

//                     {/* ═════ Selector de IMPLEMENTOS (casa + gym, siempre visible) ═════ */}
//                     {equipmentCatalog.length > 0 && (
//                       <div className="mb-5" data-testid="equipment-selector-section">
//                         <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                           ¿Qué implementos / máquinas tienes disponibles? *
//                         </Label>
//                         <p className="text-xs text-gray-300 mb-3 normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                           Marca TODO lo que puedas usar (mancuernas, barras, bandas, prensa, flexor sentado, abductor, etc.). Si entrenas en gimnasio con equipo completo, marca todas las máquinas que uses. Tu rutina se armará solo con ejercicios que puedas hacer con esos implementos.
//                         </p>
//                         <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
//                           {equipmentCatalog.map(eq => {
//                             const active = (formData.availableEquipment || []).includes(eq.id);
//                             return (
//                               <button
//                                 key={eq.id}
//                                 type="button"
//                                 data-testid={`equipment-${eq.id}`}
//                                 onClick={() => toggleEquipment(eq.id)}
//                                 className={`px-3 py-2.5 rounded-lg border-2 text-left transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
//                                 style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}
//                               >
//                                 <div className="flex items-center gap-2">
//                                   <span className="text-xl">{eq.icon}</span>
//                                   <span className={`text-xs font-semibold normal-case leading-tight ${active ? 'text-cyan-100' : 'text-white/90'}`}>
//                                     {eq.label}
//                                   </span>
//                                 </div>
//                               </button>
//                             );
//                           })}
//                         </div>
//                         {(formData.availableEquipment || []).length === 0 && (
//                           <p className="text-[11px] text-amber-300 mt-2 italic">
//                             💡 Si no marcas nada asumiremos que solo tienes peso corporal.
//                           </p>
//                         )}
//                       </div>
//                     )}

//                     {/* Duración */}
//                     <div className="mb-5">
//                       <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>Duración de tu sesión *</Label>
//                       <div className="grid grid-cols-4 gap-3">
//                         {['45min', '60min', '75min', '90min'].map(v => {
//                           const active = formData.sessionDuration === v;
//                           return (
//                             <button key={v} data-testid={`session-duration-${v}`}
//                               onClick={() => update('sessionDuration', v)}
//                               className={`p-3 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
//                               style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
//                               <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{v.replace('min', ' min')}</p>
//                             </button>
//                           );
//                         })}
//                       </div>
//                     </div>

//                     {/* Ejercicios problemáticos */}
//                     <div className="space-y-1">
//                       <Label className="text-white text-base font-semibold normal-case" style={{ letterSpacing: 'normal' }}>Ejercicios que te generan molestia (opcional)</Label>
//                       <Textarea value={formData.problematicExercises}
//                         onChange={(e) => update('problematicExercises', e.target.value)}
//                         placeholder="Ej: sentadillas profundas, peso muerto..."
//                         rows={2} className={inputCls} data-testid="textarea-problematic-exercises" />
//                     </div>

//                     {/* 💊 Suplementación */}
//                     <div className="space-y-2 pt-2">
//                       <Label className="text-white text-base font-semibold normal-case" style={{ letterSpacing: 'normal' }}>¿Usas suplementos?</Label>
//                       <div className="grid grid-cols-2 gap-2">
//                         {[
//                           { v: true, l: '💊 Sí, uso suplementos' },
//                           { v: false, l: '🥗 No, prefiero solo comida' },
//                         ].map(o => (
//                           <button
//                             key={String(o.v)}
//                             type="button"
//                             onClick={() => update('usesSupplements', o.v)}
//                             className={`p-3 rounded-lg text-sm text-left transition-all ${formData.usesSupplements === o.v ? 'bg-pink-500/25 border-2 border-pink-400' : 'bg-white/5 border border-white/15 hover:border-white/30'}`}
//                             data-testid={`btn-uses-supplements-${o.v ? 'yes' : 'no'}`}
//                           >
//                             <p className="font-semibold text-white">{o.l}</p>
//                           </button>
//                         ))}
//                       </div>
//                       <p className="text-xs text-white/60 mt-1">
//                         Los suplementos son una ayuda en tu proceso, no son obligatorios.
//                       </p>
//                     </div>
//                   </div>

//                   {/* Preferencias Alimentarias */}
//                   <div className={sectionCls} style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.25)' }}>
//                     <h3 className="font-semibold text-green-400 mb-4">Preferencias Alimentarias</h3>
//                     <div className="space-y-4">
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Alergias Alimentarias *</Label>
//                         <Textarea value={formData.allergies} onChange={(e) => update('allergies', e.target.value)}
//                           placeholder="Mariscos, nueces, lactosa, etc. Si no tienes, escribe 'Ninguna'"
//                           rows={2} className={inputCls} data-testid="textarea-allergies" />
//                       </div>
//                       <div className="space-y-1">
//                         <Label className="text-white text-sm font-semibold">Alimentos que NO te gustan *</Label>
//                         <Textarea value={formData.dislikedFoods} onChange={(e) => update('dislikedFoods', e.target.value)}
//                           placeholder="Atún, brócoli, aguacate, etc. Si no hay, escribe 'Ninguno'"
//                           rows={2} className={inputCls} data-testid="textarea-disliked" />
//                       </div>
//                     </div>
//                   </div>

//                   {/* RESULTADO */}
//                   {macros && (
//                     <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} key={`${macros.calories}-${activePref}`}>
//                       <Card style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.9), rgba(5,150,105,0.9))', border: 'none' }}>
//                         <CardContent className="py-6">
//                           <p className="text-sm text-white/80 italic mb-4 text-center" data-testid="metabolic-message">
//                             Según tu perfil metabólico, esta es la distribución de macronutrientes más adecuada para ti.
//                           </p>

//                           <h3 className="text-2xl font-bold text-white text-center mb-5" data-testid="macros-title">Tus Macros Diarios</h3>

//                           <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-4">
//                             <div className="p-4 bg-white/20 rounded-xl">
//                               <div className="text-4xl font-bold text-white" data-testid="calories-value">{macros.calories}</div>
//                               <div className="text-sm text-white/80">Calorías</div>
//                             </div>
//                             <div className="p-4 bg-white/20 rounded-xl">
//                               <div className="text-4xl font-bold text-white" data-testid="protein-value">{macros.protein}g</div>
//                               <div className="text-sm text-white/80">Proteína</div>
//                             </div>
//                             <div className="p-4 bg-white/20 rounded-xl">
//                               <div className="text-4xl font-bold text-white" data-testid="carbs-value">{macros.carbs}g</div>
//                               <div className="text-sm text-white/80">Carbohidratos</div>
//                             </div>
//                             <div className="p-4 bg-white/20 rounded-xl">
//                               <div className="text-4xl font-bold text-white" data-testid="fats-value">{macros.fats}g</div>
//                               <div className="text-sm text-white/80">Grasas</div>
//                             </div>
//                           </div>

//                           {/* Per meal */}
//                           <div className="p-3 rounded-xl bg-black/20 mb-4">
//                             <p className="text-xs text-white/60 mb-1">Por comida ({formData.mealsPerDay} comidas):</p>
//                             <div className="flex gap-4 text-sm text-white/90">
//                               <span>{Math.round(macros.calories / numMeals)} kcal</span>
//                               <span className="text-blue-300">{Math.round(macros.protein / numMeals)}g P</span>
//                               <span className="text-amber-300">{Math.round(macros.carbs / numMeals)}g C</span>
//                               <span className="text-purple-300">{Math.round(macros.fats / numMeals)}g G</span>
//                             </div>
//                           </div>

//                           {/* Explicación de la dieta */}
//                           <div className="p-3 rounded-xl bg-black/15 mb-4">
//                             <p className="text-sm font-semibold text-white/90 mb-1">
//                               {selectedDiet?.label} ({macros.pPct}%P / {macros.cPct}%C / {macros.fPct}%G)
//                             </p>
//                             <p className="text-xs text-white/60 leading-relaxed">{selectedDiet?.text}</p>
//                           </div>

//                           <div className="text-xs text-white/40 flex gap-3 mb-4">
//                             <span>TMB: {macros.tmb} kcal</span>
//                             <span>Mantenimiento: {macros.maintenance} kcal</span>
//                             <span>Ajuste: {macros.goalAdjustment > 0 ? '+' : ''}{macros.goalAdjustment}%</span>
//                           </div>

//                           <Button className="w-full bg-white text-green-600 hover:bg-gray-100 font-bold" size="lg"
//                             onClick={validateAndSubmit} disabled={loading} data-testid="btn-submit-form">
//                             {loading ? (
//                               <>Enviando...</>
//                             ) : (
//                               <><FaPaperPlane className="mr-2" /> Enviar</>
//                             )}
//                           </Button>
//                           <p className="text-sm text-white/70 text-center mt-2 normal-case" style={{ letterSpacing: 'normal' }}>
//                             Al enviar, tu plan será entregado en un lapso de 24 horas.
//                           </p>
//                         </CardContent>
//                       </Card>
//                     </motion.div>
//                   )}

//                   {!macros && (
//                     <div className="p-5 rounded-xl text-center" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px dashed rgba(255,255,255,0.15)' }}>
//                       <p className="text-gray-400 text-sm">Completa los campos para ver tus macros calculados automáticamente</p>
//                     </div>
//                   )}

//                 </CardContent>
//               </Card>
//             </motion.div>
//           )}

//           {/* MealBuilder eliminado: la dieta se maneja por RECETAS (próxima fase) */}
//         </div>
//       </div>
//     </PlanGuard>
//   );
// };

// export default MacroCalculator;

import { useState, useMemo, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PlanGuard from '@/components/PlanGuard';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';
import { FaArrowLeft, FaCalculator, FaUtensils, FaUser, FaRunning, FaBullseye, FaBrain, FaInfoCircle, FaPaperPlane } from 'react-icons/fa';
import ContinuationForm from '@/components/ContinuationForm';
import ExcludedExercisesSelector from '@/components/ExcludedExercisesSelector';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ============================================================
// CONSTANTES
// ============================================================
const ACTIVITY_LEVELS = {
  sedentario: { label: 'Sedentario', factor: 1.2, desc: 'Poco o ningún ejercicio' },
  ligero: { label: 'Ligero', factor: 1.375, desc: '1-2 días de ejercicio por semana' },
  moderado: { label: 'Moderado', factor: 1.55, desc: '3-4 días por semana' },
  alto: { label: 'Alto', factor: 1.725, desc: '5-6 días por semana' }
};

const GOALS = {
  perder_grasa: {
    label: 'Perder grasa',
    pct: -20,
    color: '#EF4444',
    tip: 'Ideal si quieres reducir % de grasa corporal y bajar de talla. Recomendado para quienes se sienten con sobrepeso, buscan verse más definidas y priorizan bajar de peso sin perder tanta masa muscular.'
  },
  ganar_musculo: {
    label: 'Ganar masa muscular',
    pct: 15,
    color: '#3B82F6',
    tip: 'Ideal si te ves delgada, tu ropa te queda holgada o quieres aumentar volumen (glúteos, piernas, brazos). Requiere entrenamiento con progresión de cargas y comer un poco más de lo que gastas.'
  },
  mantener: {
    label: 'Mantener peso',
    pct: 0,
    color: '#22C55E',
    tip: 'Ideal si estás conforme con tu peso actual y solo quieres mejorar hábitos, energía y salud. Cero superávit, cero déficit.'
  },
  recomposicion: {
    label: 'Recomposición corporal',
    pct: -5,
    color: '#F59E0B',
    tip: 'Ideal si quieres bajar grasa Y ganar músculo AL MISMO TIEMPO. Recomendado para principiantes o quienes vuelven de una pausa. Es más lento pero cambia tu cuerpo por dentro (menos grasa, más músculo) sin necesariamente bajar mucho de peso en la balanza.'
  },
};

const DIET_OPTIONS = {
  equilibrada: {
    label: 'Equilibrada', p: 30, c: 40, f: 30,
    text: 'Recomendada si no presentas problemas digestivos con ningún macronutriente y buscas una alimentación balanceada. Es ideal para la mayoría de las personas que desean mantener energía estable durante el día y una dieta sostenible a largo plazo.',
    reason: 'Tu perfil metabólico no muestra sensibilidades marcadas hacia ningún macronutriente, por eso una distribución balanceada te da energía sostenida durante todo el día y resultados constantes sin restricciones drásticas.'
  },
  alta_proteina: {
    label: 'Alta en Proteína', p: 40, c: 35, f: 25,
    text: 'Ideal si tu objetivo es aumentar o mantener masa muscular, mejorar la saciedad o controlar el apetito. También puede ser útil si entrenas con frecuencia o estás en un proceso de pérdida de grasa.',
    reason: 'Elegimos esta distribución porque tu nivel de hambre y tus entrenamientos indican que necesitas mayor saciedad y soporte muscular. La proteína te va a mantener satisfecha, controlar antojos y preservar tu masa muscular en cada ciclo.'
  },
  alta_carbos: {
    label: 'Alta en Carbohidratos', p: 25, c: 50, f: 25,
    text: 'Recomendada si tienes un metabolismo rápido, realizas entrenamientos intensos o frecuentes, o si sueles perder peso con facilidad. Este tipo de distribución puede ayudarte a mantener niveles altos de energía y mejorar el rendimiento físico.',
    reason: 'Tu metabolismo rápido y tu nivel de actividad demandan más energía disponible. Con más carbohidratos vas a rendir mejor en tus entrenamientos, recuperar el glucógeno y construir volumen muscular sin sacrificar rendimiento.'
  },
  baja_carbos: {
    label: 'Baja en Carbohidratos (Low Carb)', p: 35, c: 25, f: 40,
    text: 'Puede ser una buena opción si tiendes a sentirte inflamado al consumir muchos carbohidratos, si te cuesta perder grasa corporal o si prefieres una alimentación con mayor cantidad de grasas y proteínas que te mantenga saciado por más tiempo.',
    reason: 'Tu perfil sugiere metabolismo más lento y tendencia a retener líquidos, así que bajar los carbohidratos te ayuda a desinflamar, controlar la insulina y avanzar en tu pérdida de grasa de forma sostenida.'
  },
  alta_grasa: {
    label: 'Alta en Grasas Saludables', p: 30, c: 30, f: 40,
    text: 'Recomendada para personas que prefieren una alimentación con mayor presencia de grasas saludables como aguacate, frutos secos, aceite de oliva y pescados grasos, manteniendo una cantidad moderada de carbohidratos sin llegar a una dieta cetogénica.',
    reason: 'Tu sensibilidad hormonal, tu descanso y tu hambre baja durante el día encajan muy bien con más grasas saludables. Vas a regular tus hormonas, mejorar el sueño y sentir saciedad prolongada sin picos de energía.'
  },
  cetogenica: {
    label: 'Cetogénica (Keto)', p: 30, c: 10, f: 60,
    text: 'Indicado para quienes desean seguir una dieta muy baja en carbohidratos y alta en grasas. Este enfoque busca que el cuerpo utilice principalmente grasa como fuente de energía. Suele ser más restrictivo y se recomienda para personas que ya están familiarizadas con este tipo de alimentación.',
    reason: 'Con retención marcada y respuesta lenta a otras distribuciones, la cetogénica cambia tu fuente principal de energía a la grasa. Esto acelera la pérdida de grasa, reduce inflamación y estabiliza tu energía a lo largo del día.'
  }
};

function suggestDiet(profile) {
  const {
    metabolism = 'normal',
    hungerLevel = 'moderado',
    waterRetention = 'no',
    sleepQuality = 'buena',
    goal = ''
  } = profile || {};

  if (metabolism === 'lento' && waterRetention === 'si' && sleepQuality === 'mala') return 'cetogenica';
  if (metabolism === 'lento' && waterRetention === 'si') return 'baja_carbos';
  if (metabolism === 'rapido' && hungerLevel === 'alto') return 'alta_carbos';
  if (goal === 'perder_grasa' || goal === 'recomposicion') return 'alta_proteina';
  if (hungerLevel === 'alto' && metabolism !== 'rapido') return 'alta_proteina';
  if (sleepQuality === 'mala' && metabolism === 'lento' && waterRetention === 'no') return 'alta_grasa';
  if (goal === 'ganar_musculo' && metabolism === 'rapido') return 'alta_carbos';
  return 'equilibrada';
}

// ============================================================
// COMPONENTE PRINCIPAL
// ============================================================
const MacroCalculator = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isContinuation = searchParams.get('continuation') === 'true';

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    gender: '',
    weight: '',
    height: '',
    age: '',
    activityLevel: '',
    goal: '',
    hungerLevel: 'moderado',
    metabolism: 'normal',
    waterRetention: 'no',
    sleepQuality: 'buena',
    preference: 'equilibrada',
    mealsPerDay: '5',
    postWorkoutMeal: '',
    allergies: '',
    dislikedFoods: '',
    trainingLevel: '',
    trainingDays: '',
    trainingLocation: '',
    sessionDuration: '',
    problematicExercises: '',
    excludedExerciseIds: [],
    availableEquipment: [],
    usesSupplements: null,
  });
  const [equipmentCatalog, setEquipmentCatalog] = useState([]);

  useEffect(() => {
    let ignore = false;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/fit-evolution/equipment-catalog`)
      .then(r => { if (!ignore) setEquipmentCatalog(r.data?.catalog || []); })
      .catch(() => {});
    return () => { ignore = true; };
  }, []);

  const toggleEquipment = (id) => {
    setFormData(prev => {
      const has = (prev.availableEquipment || []).includes(id);
      return {
        ...prev,
        availableEquipment: has
          ? prev.availableEquipment.filter(x => x !== id)
          : [...(prev.availableEquipment || []), id],
      };
    });
  };

  const update = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

  const suggestedDiet = useMemo(() => {
    return suggestDiet({
      metabolism: formData.metabolism,
      hungerLevel: formData.hungerLevel,
      waterRetention: formData.waterRetention,
      sleepQuality: formData.sleepQuality,
      goal: formData.goal,
    });
  }, [formData.metabolism, formData.hungerLevel, formData.waterRetention, formData.sleepQuality, formData.goal]);

  const [manualDiet, setManualDiet] = useState(false);
  const activePref = manualDiet ? formData.preference : suggestedDiet;
  const selectedDiet = DIET_OPTIONS[activePref];
  const dietReason = (DIET_OPTIONS[activePref]?.reason) || 'El sistema eligió esta dieta según tu perfil metabólico.';

  // ============================================================
  // CÁLCULO DINÁMICO DE MACROS
  // ============================================================
  const macros = useMemo(() => {
    const w = parseFloat(formData.weight) || 0;
    const hStr = String(formData.height || '');
    // Ignorar cálculo si la estatura incluye decimales para evitar TMB distorsionada
    if (hStr.includes('.') || hStr.includes(',')) return null;

    const h = parseFloat(formData.height) || 0;
    const a = parseInt(formData.age) || 0;
    if (w <= 0 || h < 100 || h > 250 || a <= 0 || !formData.gender || !formData.activityLevel || !formData.goal) return null;

    let tmb;
    if (formData.gender === 'male') {
      tmb = (10 * w) + (6.25 * h) - (5 * a) + 5;
    } else {
      tmb = (10 * w) + (6.25 * h) - (5 * a) - 161;
    }

    const actFactor = ACTIVITY_LEVELS[formData.activityLevel]?.factor || 1.55;
    const maintenance = Math.round(tmb * actFactor);
    const goalAdj = GOALS[formData.goal]?.pct || 0;
    const targetCalories = Math.round(maintenance * (1 + goalAdj / 100));

    const diet = DIET_OPTIONS[activePref] || DIET_OPTIONS.equilibrada;
    const proteinG = Math.round((targetCalories * diet.p / 100) / 4);
    const carbsG = Math.round((targetCalories * diet.c / 100) / 4);
    const fatsG = Math.round((targetCalories * diet.f / 100) / 9);

    return {
      calories: targetCalories, protein: proteinG, carbs: carbsG, fats: fatsG,
      method: 'Mifflin-St Jeor', tmb: Math.round(tmb), maintenance, goalAdjustment: goalAdj,
      pPct: diet.p, cPct: diet.c, fPct: diet.f
    };
  }, [formData.weight, formData.height, formData.age, formData.gender, formData.activityLevel, formData.goal, activePref]);

  const validateAndSubmit = async () => {
    if (!formData.fullName || !formData.email) { toast.error('Completa tu nombre y correo electrónico'); return; }
    
    // 🛑 VALIDACIÓN DE ESTATURA (bloquea puntos, comas y rangos inválidos)
    const heightStr = String(formData.height || '');
    const heightNum = parseFloat(formData.height);
    if (heightStr.includes('.') || heightStr.includes(',')) {
      toast.error('Ingresa tu estatura en centímetros, sin puntos (ejemplo: 162, no 1.62)');
      return;
    }
    if (isNaN(heightNum) || heightNum < 100 || heightNum > 250) {
      toast.error('Ingresa una estatura válida en centímetros (entre 100 y 250 cm)');
      return;
    }

    if (!macros) { toast.error('Completa todos los campos requeridos correctamente'); return; }
    if (!formData.postWorkoutMeal) { toast.error('Selecciona tu comida post entrenamiento'); return; }
    if (!formData.allergies || !formData.dislikedFoods) { toast.error('Indica tus alergias y alimentos que no te gustan (escribe "Ninguna" si no aplica)'); return; }
    if (!formData.trainingLevel) { toast.error('Selecciona tu nivel de entrenamiento'); return; }
    if (!formData.trainingDays) { toast.error('Indica cuántos días entrenas por semana'); return; }
    if (!formData.trainingLocation) { toast.error('Selecciona dónde vas a entrenar (Casa / Gym / Ambos)'); return; }
    if (!formData.sessionDuration) { toast.error('Selecciona la duración de tu sesión'); return; }

    setLoading(true);
    try {
      const token = localStorage.getItem('deisycfit_token');
      const mealsCount = parseInt(formData.mealsPerDay) || 5;
      await axios.post(`${API}/meal-plan/save`, {
        selectedFoods: {},
        macros: { calories: macros.calories, protein: macros.protein, carbs: macros.carbs, fats: macros.fats },
        formData: { fullName: formData.fullName || '', email: formData.email || '' },
        mealsCount,
        postWorkoutMeal: formData.postWorkoutMeal || '2',
        allergies: formData.allergies || '',
        dislikedFoods: formData.dislikedFoods || '',
        profile_data: {
          gender: formData.gender,
          age: parseInt(formData.age) || undefined,
          weight: parseFloat(formData.weight) || undefined,
          height: parseFloat(formData.height) || undefined,
          activity_level: formData.activityLevel,
          goal: formData.goal,
        },
        metabolic_profile: {
          metabolism: formData.metabolism,
          hunger_level: formData.hungerLevel,
          water_retention: formData.waterRetention,
          sleep_quality: formData.sleepQuality,
          goal: formData.goal,
          recommended_diet: activePref,
          recommended_diet_label: DIET_OPTIONS[activePref]?.label,
        },
        training_profile: {
          level: formData.trainingLevel,
          training_days: formData.trainingDays,
          training_location: formData.trainingLocation,
          session_duration: formData.sessionDuration,
          problematic_exercises: formData.problematicExercises,
          excluded_exercise_ids: formData.excludedExerciseIds || [],
          available_equipment: (formData.availableEquipment || []),
          goal: formData.goal,
          training_experience: formData.trainingLevel,
        },
        uses_supplements: formData.usesSupplements === true,
      }, { headers: token ? { 'Authorization': `Bearer ${token}` } : {} });
      
      toast.success('¡Formulario enviado! Recuerda que tu plan estará listo 24 horas después de que adjuntes tus fotos iniciales. ¡Adjúntalas ya!', { duration: 8000 });
      try { sessionStorage.setItem('fe_just_submitted', String(Date.now())); } catch (_e) { /* noop */ }
      setTimeout(() => navigate('/fit-evolution/preparing', { replace: true }), 800);
    } catch (error) {
      console.error('Error enviando formulario:', error.response?.data || error.message);
      toast.error(error.response?.data?.detail || 'Error al enviar el formulario');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "bg-white/15 border-white/30 text-white font-medium text-base placeholder:text-gray-400";
  const sectionCls = "p-5 rounded-xl";
  const numMeals = parseInt(formData.mealsPerDay) || 5;

  if (isContinuation) {
    return (
      <PlanGuard allowedPlans={['basic']}>
        <div className="min-h-screen py-12 px-4" style={{ background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)' }}>
          <div className="max-w-4xl mx-auto">
            <button onClick={() => navigate('/dashboard')} className="flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors">
              <FaArrowLeft /> Volver al Dashboard
            </button>
            <ContinuationForm formType="diet" onSuccess={() => navigate('/dashboard')} onCancel={() => navigate('/dashboard')} />
          </div>
        </div>
      </PlanGuard>
    );
  }

  return (
    <PlanGuard requiredPlan="basic" featureName="el Generador de Dietas">
      <div className="min-h-screen py-12 px-6" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="fixed inset-0 z-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at 20% 80%, rgba(var(--brand-primary-glow),0.12), transparent 50%), radial-gradient(circle at 80% 20%, rgba(0,240,255,0.08), transparent 40%)'
        }} />

        <div className="max-w-5xl mx-auto relative z-10">
          <Button variant="ghost" onClick={() => navigate('/dashboard')}
            className="mb-6 text-gray-400 hover:text-white hover:bg-white/10" data-testid="back-button">
            <FaArrowLeft className="mr-2" /> Volver al Dashboard
          </Button>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Card style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <CardHeader>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center text-white"
                    style={{ background: 'linear-gradient(135deg, var(--brand-primary), #00F0FF)' }}>
                    <FaCalculator className="text-2xl" />
                  </div>
                  <div>
                    <CardTitle className="text-3xl text-white font-black" data-testid="page-title">Mi Plan de Alimentación</CardTitle>
                    <CardDescription className="text-gray-200 text-base">Diseñamos tu plan de alimentación perfecto según tus metas</CardDescription>
                  </div>
                </div>
              </CardHeader>
              <CardContent className="space-y-5">

                {/* Datos de contacto */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(0,240,255,0.08)', border: '1px solid rgba(0,240,255,0.25)' }}>
                  <h3 className="font-semibold text-cyan-400 mb-4">Datos de Contacto</h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Nombre Completo *</Label>
                      <Input value={formData.fullName} onChange={(e) => update('fullName', e.target.value)}
                        placeholder="Tu nombre completo" className={inputCls} data-testid="input-fullname" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Correo Electrónico *</Label>
                      <Input type="email" value={formData.email} onChange={(e) => update('email', e.target.value)}
                        placeholder="tu@email.com" className={inputCls} data-testid="input-email" />
                    </div>
                  </div>
                </div>

                {/* SECCIÓN 1 — DATOS PERSONALES */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(var(--brand-primary-glow),0.08)', border: '1px solid rgba(var(--brand-primary-glow),0.25)' }}>
                  <h3 className="font-semibold text-pink-400 mb-4 flex items-center gap-2">
                    <FaUser /> Sección 1 — Datos Personales
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Sexo *</Label>
                      <Select value={formData.gender} onValueChange={(v) => update('gender', v)}>
                        <SelectTrigger className={inputCls} data-testid="select-gender"><SelectValue placeholder="Selecciona" /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="male">Hombre</SelectItem>
                          <SelectItem value="female">Mujer</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Edad *</Label>
                      <Input type="number" value={formData.age} onChange={(e) => update('age', e.target.value)}
                        placeholder="30" className={inputCls} data-testid="input-age" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Peso (kg) *</Label>
                      <Input type="number" value={formData.weight} onChange={(e) => update('weight', e.target.value)}
                        placeholder="65" className={inputCls} data-testid="input-weight" />
                    </div>
                    
                    {/* ESTATURA CON VALIDACIÓN */}
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Estatura (cm) *</Label>
                      <Input 
                        type="text" 
                        value={formData.height} 
                        onChange={(e) => update('height', e.target.value)}
                        placeholder="162" 
                        className={inputCls} 
                        data-testid="input-height" 
                      />
                      <p className="text-xs text-amber-400/80">Sin puntos. Ej: 162 cm, no 1.62</p>
                      {(formData.height.includes('.') || formData.height.includes(',')) && (
                        <p className="text-xs text-red-400 font-bold mt-1">
                          ❌ Ingresa tu estatura en centímetros, sin puntos (ejemplo: 162, no 1.62)
                        </p>
                      )}
                      {formData.height && !formData.height.includes('.') && !formData.height.includes(',') && (parseFloat(formData.height) < 100 || parseFloat(formData.height) > 250) && (
                        <p className="text-xs text-red-400 font-bold mt-1">
                          ❌ Estatura fuera de rango válido (100 a 250 cm)
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* SECCIÓN 2 — ACTIVIDAD FÍSICA */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.25)' }}>
                  <h3 className="font-semibold text-emerald-400 mb-4 flex items-center gap-2">
                    <FaRunning /> Sección 2 — Actividad Física
                  </h3>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {Object.entries(ACTIVITY_LEVELS).map(([key, val]) => {
                      const active = formData.activityLevel === key;
                      return (
                        <button key={key} data-testid={`activity-${key}`}
                          className={`p-4 rounded-xl border text-left transition-all ${
                            active ? 'border-emerald-500 bg-emerald-500/20 ring-1 ring-emerald-500' : 'border-white/10 bg-white/5 hover:border-white/25'
                          }`}
                          onClick={() => update('activityLevel', key)}>
                          <p className={`text-sm font-bold ${active ? 'text-emerald-300' : 'text-white'}`}>{val.label}</p>
                          <p className="text-[11px] text-gray-200 mt-1">{val.desc}</p>
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* SECCIÓN 3 — OBJETIVO */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)' }}>
                  <h3 className="font-semibold text-amber-400 mb-4 flex items-center gap-2">
                    <FaBullseye /> Sección 3 — Objetivo
                  </h3>
                  <p className="text-xs text-gray-200 mb-4 leading-relaxed">
                    Toca cada opción para leer la recomendación y elegir la que mejor se ajusta a tu meta actual. Puedes cambiarla más adelante si tu proceso evoluciona.
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {Object.entries(GOALS).map(([key, val]) => {
                      const active = formData.goal === key;
                      return (
                        <button key={key} data-testid={`goal-${key}`}
                          className={`p-4 rounded-xl border text-center transition-all ${
                            active ? 'ring-1' : 'border-white/10 bg-white/5 hover:border-white/25'
                          }`}
                          style={active ? { borderColor: val.color, backgroundColor: `${val.color}22`, boxShadow: `0 0 0 1px ${val.color}` } : {}}
                          onClick={() => { update('goal', key); setManualDiet(false); }}>
                          <p className={`text-sm font-bold ${active ? 'text-white' : 'text-white/95'}`}>{val.label}</p>
                          <p className="text-[11px] text-gray-200 mt-1">{val.pct > 0 ? '+' : ''}{val.pct}% kcal</p>
                        </button>
                      );
                    })}
                  </div>
                  {formData.goal && GOALS[formData.goal]?.tip && (
                    <div
                      className="mt-4 rounded-xl p-4 text-sm leading-relaxed"
                      style={{
                        background: `${GOALS[formData.goal].color}15`,
                        border: `1px solid ${GOALS[formData.goal].color}40`,
                        color: '#F5F5F5'
                      }}
                      data-testid={`goal-tip-${formData.goal}`}
                    >
                      <p className="font-bold mb-1" style={{ color: GOALS[formData.goal].color }}>
                        💡 ¿Cuándo elegir "{GOALS[formData.goal].label}"?
                      </p>
                      <p className="text-gray-100">{GOALS[formData.goal].tip}</p>
                    </div>
                  )}
                </div>

                {/* SECCIÓN 4 — PERFIL METABÓLICO */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(168,85,247,0.08)', border: '1px solid rgba(168,85,247,0.25)' }}>
                  <h3 className="font-semibold text-purple-400 mb-2 flex items-center gap-2">
                    <FaBrain /> Sección 4 — Perfil Metabólico
                  </h3>
                  <p className="text-xs text-gray-200 mb-5">Estas preguntas ayudan al sistema a decidir la distribución de macronutrientes.</p>

                  <div className="space-y-5">
                    <div>
                      <p className="text-base text-gray-100 mb-3">¿Cómo es tu nivel de hambre durante el día?</p>
                      <div className="grid grid-cols-3 gap-3">
                        {[
                          { id: 'alto', label: 'Alto', emoji: '🍽️', desc: 'Como y sigues con ganas de más' },
                          { id: 'moderado', label: 'Moderado', emoji: '👌', desc: 'Comes y quedas satisfecha' },
                          { id: 'bajo', label: 'Bajo', emoji: '🤏', desc: 'A veces se te olvida comer' }
                        ].map(opt => {
                          const active = formData.hungerLevel === opt.id;
                          return (
                            <button key={opt.id} data-testid={`hunger-${opt.id}`}
                              className={`p-3 rounded-xl border text-center transition-all ${
                                active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
                              }`}
                              onClick={() => { update('hungerLevel', opt.id); setManualDiet(false); }}>
                              <span className="text-xl">{opt.emoji}</span>
                              <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
                              <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <p className="text-base text-gray-100 mb-3">¿Cómo describirías tu metabolismo?</p>
                      <div className="grid grid-cols-3 gap-3">
                        {[
                          { id: 'rapido', label: 'Rápido', emoji: '🔥', desc: 'Comes mucho y no subes de peso fácil' },
                          { id: 'normal', label: 'Normal', emoji: '⚖️', desc: 'Tu peso se mantiene con dieta equilibrada' },
                          { id: 'lento', label: 'Lento', emoji: '🐢', desc: 'Subes de peso con facilidad aunque comas poco' }
                        ].map(opt => {
                          const active = formData.metabolism === opt.id;
                          return (
                            <button key={opt.id} type="button" data-testid={`metabolism-${opt.id}`}
                              className={`p-3 rounded-xl border text-center transition-all ${
                                active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
                              }`}
                              onClick={() => { update('metabolism', opt.id); setManualDiet(false); }}>
                              <span className="text-xl">{opt.emoji}</span>
                              <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
                              <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <p className="text-base text-gray-100 mb-3">¿Sueles retener líquidos?</p>
                      <div className="grid grid-cols-2 gap-3">
                        {[
                          { id: 'si', label: 'Sí', emoji: '💧', desc: 'Manos, cara o piernas hinchadas con frecuencia' },
                          { id: 'no', label: 'No', emoji: '✨', desc: 'No sientes hinchazón normalmente' }
                        ].map(opt => {
                          const active = formData.waterRetention === opt.id;
                          return (
                            <button key={opt.id} type="button" data-testid={`retention-${opt.id}`}
                              className={`p-3 rounded-xl border text-center transition-all ${
                                active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
                              }`}
                              onClick={() => { update('waterRetention', opt.id); setManualDiet(false); }}>
                              <span className="text-xl">{opt.emoji}</span>
                              <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
                              <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <div>
                      <p className="text-base text-gray-100 mb-3">¿Cómo describirías tu calidad de sueño?</p>
                      <div className="grid grid-cols-3 gap-3">
                        {[
                          { id: 'buena', label: 'Buena', emoji: '😌', desc: '7-9 horas seguidas y despiertas descansada' },
                          { id: 'regular', label: 'Regular', emoji: '😐', desc: '5-6 horas o te despiertas varias veces' },
                          { id: 'mala', label: 'Mala', emoji: '😩', desc: 'Menos de 5 horas o insomnio frecuente' }
                        ].map(opt => {
                          const active = formData.sleepQuality === opt.id;
                          return (
                            <button key={opt.id} type="button" data-testid={`sleep-${opt.id}`}
                              className={`p-3 rounded-xl border text-center transition-all ${
                                active ? 'border-purple-500 bg-purple-500/20 ring-1 ring-purple-500' : 'border-white/10 bg-white/5 hover:border-white/25'
                              }`}
                              onClick={() => { update('sleepQuality', opt.id); setManualDiet(false); }}>
                              <span className="text-xl">{opt.emoji}</span>
                              <p className={`text-xs mt-1 ${active ? 'text-purple-300 font-bold' : 'text-white/90'}`}>{opt.label}</p>
                              <p className="text-xs text-gray-200 mt-1 leading-tight">{opt.desc}</p>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* SECCIÓN 5 — DIETA RECOMENDADA AUTOMÁTICAMENTE */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(var(--brand-primary-glow),0.08)', border: '1px solid rgba(var(--brand-primary-glow),0.25)' }} data-testid="diet-auto-recommendation-section">
                  <h3 className="font-semibold text-pink-400 mb-2 flex items-center gap-2">
                    <FaUtensils /> Sección 5 — Tu Dieta Recomendada
                  </h3>
                  <p className="text-xs text-gray-400 mb-4">
                    El sistema eligió automáticamente el tipo de dieta más adecuado según tu perfil metabólico, hambre, sueño y objetivo. No necesitas elegir nada.
                  </p>

                  {selectedDiet && (
                    <div className="p-4 rounded-xl border border-pink-500/40 bg-pink-500/10" data-testid="diet-explanation">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-lg font-bold text-pink-300" data-testid="diet-recommended-label">{selectedDiet.label}</p>
                        <span className="text-xs px-2 py-1 rounded-full bg-pink-500/20 text-pink-300 font-semibold">Recomendada para ti</span>
                      </div>
                      <p className="text-xs text-gray-200 mb-3" data-testid="diet-recommended-macros">
                        {DIET_OPTIONS[activePref].p}% Proteína / {DIET_OPTIONS[activePref].c}% Carbohidratos / {DIET_OPTIONS[activePref].f}% Grasas
                      </p>
                      <div className="mb-3 p-3 rounded-lg border border-purple-500/30 bg-purple-500/10" data-testid="diet-reason-box">
                        <p className="text-xs uppercase tracking-wider text-purple-300 font-bold mb-1">¿Por qué esta dieta?</p>
                        <p className="text-sm text-purple-100" data-testid="diet-reason-text">{dietReason}</p>
                      </div>
                      <p className="text-base text-gray-100 leading-relaxed">{selectedDiet.text}</p>
                    </div>
                  )}

                  <p className="text-xs text-gray-200 mt-3 flex items-start gap-2">
                    <FaInfoCircle className="mt-0.5 flex-shrink-0 text-gray-600" />
                    Si cambias alguna de las respuestas de tu perfil metabólico, la dieta recomendada se actualizará automáticamente.
                  </p>
                </div>

                {/* Configuración de Comidas */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(99,102,241,0.08)', border: '1px solid rgba(99,102,241,0.25)' }}>
                  <h3 className="font-semibold text-indigo-400 mb-4">Configuración de Comidas</h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Comidas por Día</Label>
                      <Select value={formData.mealsPerDay} onValueChange={(v) => update('mealsPerDay', v)}>
                        <SelectTrigger className={inputCls} data-testid="select-meals"><SelectValue /></SelectTrigger>
                        <SelectContent>
                          {[3,4,5,6,7].map(n => <SelectItem key={n} value={String(n)}>{n} comidas</SelectItem>)}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Comida Post Entrenamiento <span className="text-white/60 font-normal">(la comida después de entrenar)</span> *</Label>
                      <Select value={formData.postWorkoutMeal} onValueChange={(v) => update('postWorkoutMeal', v)}>
                        <SelectTrigger className={inputCls} data-testid="select-post-workout"><SelectValue placeholder="Selecciona" /></SelectTrigger>
                        <SelectContent>
                          {Array.from({ length: numMeals }, (_, i) => i + 1).map(n => (
                            <SelectItem key={n} value={String(n)}>Comida {n}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      <p className="text-xs text-gray-200">Sin grasas añadidas. En días de descanso se omite esta comida.</p>
                    </div>
                  </div>
                </div>

                {/* SECCIÓN 6 — ENTRENAMIENTO */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(0,240,255,0.10)', border: '1px solid rgba(0,240,255,0.30)', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                  <h3 className="font-bold text-cyan-300 text-lg mb-4 flex items-center gap-2 normal-case" style={{ letterSpacing: 'normal' }}>
                    <FaRunning /> Sección 6 — Entrenamiento
                  </h3>
                  <p className="text-base text-gray-100 mb-5 normal-case" style={{ letterSpacing: 'normal' }}>Con esto armamos tu rutina personalizada Fit Evolution.</p>

                  <div className="mb-5">
                    <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal' }}>Tu nivel de entrenamiento *</Label>
                    <div className="grid grid-cols-3 gap-3">
                      {[
                        { v: 'novato', l: 'Novato', d: 'Nunca he entrenado o poco tiempo' },
                        { v: 'intermedio', l: 'Intermedio', d: 'Entreno hace 6+ meses' },
                        { v: 'avanzado', l: 'Avanzado', d: 'Entreno hace 2+ años' }
                      ].map(o => {
                        const active = formData.trainingLevel === o.v;
                        return (
                          <button key={o.v} data-testid={`training-level-${o.v}`}
                            onClick={() => update('trainingLevel', o.v)}
                            className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
                            style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                            <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.l}</p>
                            <p className="text-sm text-gray-100 mt-1 leading-snug normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.d}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="mb-5">
                    <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>Días que entrenas por semana *</Label>
                    <div className="grid grid-cols-4 gap-3">
                      {['3', '4', '5', '6'].map(v => {
                        const active = formData.trainingDays === v;
                        return (
                          <button key={v} data-testid={`training-days-${v}`}
                            onClick={() => update('trainingDays', v)}
                            className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
                            style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                            <p className={`font-black text-2xl normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{v}</p>
                            <p className="text-sm text-gray-100 normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>días</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="mb-5">
                    <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>¿Dónde vas a entrenar? *</Label>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                      {[
                        { v: 'casa', l: 'En Casa', d: 'Material básico o sin equipo', i: '🏠' },
                        { v: 'gym', l: 'En el Gym', d: 'Máquinas y peso libre', i: '🏋️' },
                        { v: 'ambos', l: 'Ambos', d: 'A veces casa, a veces gym', i: '🔀' }
                      ].map(o => {
                        const active = formData.trainingLocation === o.v;
                        return (
                          <button key={o.v} data-testid={`training-location-${o.v}`}
                            onClick={() => update('trainingLocation', o.v)}
                            className={`p-4 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
                            style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                            <div className="text-3xl mb-1">{o.i}</div>
                            <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.l}</p>
                            <p className="text-sm text-gray-100 mt-1 leading-snug normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{o.d}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {equipmentCatalog.length > 0 && (
                    <div className="mb-5" data-testid="equipment-selector-section">
                      <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                        ¿Qué implementos / máquinas tienes disponibles? *
                      </Label>
                      <p className="text-xs text-gray-300 mb-3 normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                        Marca TODO lo que puedas usar (mancuernas, barras, bandas, prensa, flexor sentado, abductor, etc.). Si entrenas en gimnasio con equipo completo, marca todas las máquinas que uses. Tu rutina se armará solo con ejercicios que puedas hacer con esos implementos.
                      </p>
                      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                        {equipmentCatalog.map(eq => {
                          const active = (formData.availableEquipment || []).includes(eq.id);
                          return (
                            <button
                              key={eq.id}
                              type="button"
                              data-testid={`equipment-${eq.id}`}
                              onClick={() => toggleEquipment(eq.id)}
                              className={`px-3 py-2.5 rounded-lg border-2 text-left transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
                              style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}
                            >
                              <div className="flex items-center gap-2">
                                <span className="text-xl">{eq.icon}</span>
                                <span className={`text-xs font-semibold normal-case leading-tight ${active ? 'text-cyan-100' : 'text-white/90'}`}>
                                  {eq.label}
                                </span>
                              </div>
                            </button>
                          );
                        })}
                      </div>
                      {(formData.availableEquipment || []).length === 0 && (
                        <p className="text-[11px] text-amber-300 mt-2 italic">
                          💡 Si no marcas nada asumiremos que solo tienes peso corporal.
                        </p>
                      )}
                    </div>
                  )}

                  <div className="mb-5">
                    <Label className="text-white text-base font-semibold mb-2 block normal-case" style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>Duración de tu sesión *</Label>
                    <div className="grid grid-cols-4 gap-3">
                      {['45min', '60min', '75min', '90min'].map(v => {
                        const active = formData.sessionDuration === v;
                        return (
                          <button key={v} data-testid={`session-duration-${v}`}
                            onClick={() => update('sessionDuration', v)}
                            className={`p-3 rounded-xl border-2 text-center transition-all ${active ? 'bg-cyan-500/25 border-cyan-400 ring-1 ring-cyan-400' : 'bg-white/5 border-white/15 hover:border-white/30'}`}
                            style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>
                            <p className={`font-bold text-base normal-case ${active ? 'text-cyan-200' : 'text-white'}`} style={{ letterSpacing: 'normal', fontFamily: 'DM Sans, system-ui, sans-serif' }}>{v.replace('min', ' min')}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <Label className="text-white text-base font-semibold normal-case" style={{ letterSpacing: 'normal' }}>Ejercicios que te generan molestia (opcional)</Label>
                    <Textarea value={formData.problematicExercises}
                      onChange={(e) => update('problematicExercises', e.target.value)}
                      placeholder="Ej: sentadillas profundas, peso muerto..."
                      rows={2} className={inputCls} data-testid="textarea-problematic-exercises" />
                  </div>

                  <div className="space-y-1">
                    <Label className="text-white text-base font-semibold normal-case" style={{ letterSpacing: 'normal' }}>O márcalos en el catálogo (opcional)</Label>
                    <ExcludedExercisesSelector
                      value={formData.excludedExerciseIds}
                      onChange={(next) => update('excludedExerciseIds', next)}
                      testIdPrefix="macro"
                    />
                  </div>

                  <div className="space-y-2 pt-2">
                    <Label className="text-white text-base font-semibold normal-case" style={{ letterSpacing: 'normal' }}>¿Usas suplementos?</Label>
                    <div className="grid grid-cols-2 gap-2">
                      {[
                        { v: true, l: '💊 Sí, uso suplementos' },
                        { v: false, l: '🥗 No, prefiero solo comida' },
                      ].map(o => (
                        <button
                          key={String(o.v)}
                          type="button"
                          onClick={() => update('usesSupplements', o.v)}
                          className={`p-3 rounded-lg text-sm text-left transition-all ${formData.usesSupplements === o.v ? 'bg-pink-500/25 border-2 border-pink-400' : 'bg-white/5 border border-white/15 hover:border-white/30'}`}
                          data-testid={`btn-uses-supplements-${o.v ? 'yes' : 'no'}`}
                        >
                          <p className="font-semibold text-white">{o.l}</p>
                        </button>
                      ))}
                    </div>
                    <p className="text-xs text-white/60 mt-1">
                      Los suplementos son una ayuda en tu proceso, no son obligatorios.
                    </p>
                  </div>
                </div>

                {/* Preferencias Alimentarias */}
                <div className={sectionCls} style={{ backgroundColor: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.25)' }}>
                  <h3 className="font-semibold text-green-400 mb-4">Preferencias Alimentarias</h3>
                  <div className="space-y-4">
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Alergias Alimentarias *</Label>
                      <Textarea value={formData.allergies} onChange={(e) => update('allergies', e.target.value)}
                        placeholder="Mariscos, nueces, lactosa, etc. Si no tienes, escribe 'Ninguna'"
                        rows={2} className={inputCls} data-testid="textarea-allergies" />
                    </div>
                    <div className="space-y-1">
                      <Label className="text-white text-sm font-semibold">Alimentos que NO te gustan *</Label>
                      <Textarea value={formData.dislikedFoods} onChange={(e) => update('dislikedFoods', e.target.value)}
                        placeholder="Atún, brócoli, aguacate, etc. Si no hay, escribe 'Ninguno'"
                        rows={2} className={inputCls} data-testid="textarea-disliked" />
                    </div>
                  </div>
                </div>

                {/* RESULTADO */}
                {macros && (
                  <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} key={`${macros.calories}-${activePref}`}>
                    <Card style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.9), rgba(5,150,105,0.9))', border: 'none' }}>
                      <CardContent className="py-6">
                        <p className="text-sm text-white/80 italic mb-4 text-center" data-testid="metabolic-message">
                          Según tu perfil metabólico, esta es la distribución de macronutrientes más adecuada para ti.
                        </p>

                        <h3 className="text-2xl font-bold text-white text-center mb-5" data-testid="macros-title">Tus Macros Diarios</h3>

                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-4">
                          <div className="p-4 bg-white/20 rounded-xl">
                            <div className="text-4xl font-bold text-white" data-testid="calories-value">{macros.calories}</div>
                            <div className="text-sm text-white/80">Calorías</div>
                          </div>
                          <div className="p-4 bg-white/20 rounded-xl">
                            <div className="text-4xl font-bold text-white" data-testid="protein-value">{macros.protein}g</div>
                            <div className="text-sm text-white/80">Proteína</div>
                          </div>
                          <div className="p-4 bg-white/20 rounded-xl">
                            <div className="text-4xl font-bold text-white" data-testid="carbs-value">{macros.carbs}g</div>
                            <div className="text-sm text-white/80">Carbohidratos</div>
                          </div>
                          <div className="p-4 bg-white/20 rounded-xl">
                            <div className="text-4xl font-bold text-white" data-testid="fats-value">{macros.fats}g</div>
                            <div className="text-sm text-white/80">Grasas</div>
                          </div>
                        </div>

                        <div className="p-3 rounded-xl bg-black/20 mb-4">
                          <p className="text-xs text-white/60 mb-1">Por comida ({formData.mealsPerDay} comidas):</p>
                          <div className="flex gap-4 text-sm text-white/90">
                            <span>{Math.round(macros.calories / numMeals)} kcal</span>
                            <span className="text-blue-300">{Math.round(macros.protein / numMeals)}g P</span>
                            <span className="text-amber-300">{Math.round(macros.carbs / numMeals)}g C</span>
                            <span className="text-purple-300">{Math.round(macros.fats / numMeals)}g G</span>
                          </div>
                        </div>

                        <div className="p-3 rounded-xl bg-black/15 mb-4">
                          <p className="text-sm font-semibold text-white/90 mb-1">
                            {selectedDiet?.label} ({macros.pPct}%P / {macros.cPct}%C / {macros.fPct}%G)
                          </p>
                          <p className="text-xs text-white/60 leading-relaxed">{selectedDiet?.text}</p>
                        </div>

                        <div className="text-xs text-white/40 flex gap-3 mb-4">
                          <span>TMB: {macros.tmb} kcal</span>
                          <span>Mantenimiento: {macros.maintenance} kcal</span>
                          <span>Ajuste: {macros.goalAdjustment > 0 ? '+' : ''}{macros.goalAdjustment}%</span>
                        </div>

                        <Button className="w-full bg-white text-green-600 hover:bg-gray-100 font-bold" size="lg"
                          onClick={validateAndSubmit} disabled={loading} data-testid="btn-submit-form">
                          {loading ? (
                            <>Enviando...</>
                          ) : (
                            <><FaPaperPlane className="mr-2" /> Enviar</>
                          )}
                        </Button>
                        <p className="text-sm text-white/70 text-center mt-2 normal-case" style={{ letterSpacing: 'normal' }}>
                          Al enviar, tu plan será entregado en un lapso de 24 horas.
                        </p>
                      </CardContent>
                    </Card>
                  </motion.div>
                )}

                {!macros && (
                  <div className="p-5 rounded-xl text-center" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px dashed rgba(255,255,255,0.15)' }}>
                    <p className="text-gray-400 text-sm">Completa los campos para ver tus macros calculados automáticamente</p>
                  </div>
                )}

              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </PlanGuard>
  );
};

export default MacroCalculator;